import { useNavigate } from 'react-router-dom'

import NormalTopBar from '@/components/common/bar/NormalTopBar'
import TermsOfUse from '@/assets/TermsOfUse'
import BigCard from '@/components/common/card/BigCard'
import { useScrollToTop } from '@/hooks/useScrollToTop'

const ServiceUsagePage = () => {
  useScrollToTop()

  const navigate = useNavigate()

  return (
    <>
      <NormalTopBar
        title='서비스 이용약관'
        prevButton
        onPrevButtonClick={() => navigate('/my')}
        textClassName='text-xl text-text-header font-semibold'
        boxClassName='bg-gradient-to-r from-amber-400 to-yellow-300'
      />
      <div className='min-h-screen p-3 overflow-y-hidden flex flex-col gap-3'>
        <BigCard className='shadow-md px-3 py-5'>
          <TermsOfUse />
        </BigCard>
      </div>
    </>
  )
}

export default ServiceUsagePage
